import { AnDetailsModal } from "./an-details-modal";

class AnPasswordModal extends AnDetailsModal {
  override connectedCallback(): void {
    super.connectedCallback();
    if (this.querySelector('input[aria-invalid="true"]')) {
      this.open({ target: this.querySelector("details") });
    }
  }
}

customElements.define("an-password-modal", AnPasswordModal);
